// Timezone-aware date/money formatting helpers — 2026-06-17
// All date strings from the API are UTC. Display converts to tenant timezone from preferences.
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

// Map PHP date() tokens to dayjs tokens (same token set as moment.js)
export function phpToDayjs (phpFormat) {
  const map = { d: 'DD', M: 'MMM', Y: 'YYYY', m: 'MM', j: 'D', H: 'HH', h: 'hh', i: 'mm', s: 'ss' }
  return (phpFormat || 'd M Y').replace(/[dMYmjHhis]/g, t => map[t] || t)
}

function getPrefs () {
  try {
    return JSON.parse(localStorage.getItem('preferences') || '{}')
  } catch (e) {
    return {}
  }
}

// Format a UTC datetime string as date-only in the tenant's local timezone
export function formatDate (dateString, prefs) {
  if (!dateString) return '-'
  const p   = prefs || getPrefs()
  const tz  = p.timezone    || 'Indian/Mauritius'
  const fmt = phpToDayjs(p.date_format || 'd M Y')
  return dayjs.utc(dateString).tz(tz).format(fmt)
}

// Format a UTC datetime string as date + time in the tenant's local timezone
export function formatDateTime (dateString, prefs) {
  if (!dateString) return '-'
  const p   = prefs || getPrefs()
  const tz  = p.timezone    || 'Indian/Mauritius'
  const fmt = phpToDayjs(p.date_format || 'd M Y') + ' h:mm a'
  return dayjs.utc(dateString).tz(tz).format(fmt)
}

// Relative time string ("3 days ago")
export function fromNow (dateString) {
  if (!dateString) return ''
  return dayjs.utc(dateString).fromNow()
}

// Format a numeric value as currency using tenant preferences
export function formatMoney (value, prefs) {
  const p        = prefs || getPrefs()
  const currency = p.currency          || 'Rs.'
  const position = p.currency_position || 'before'
  const formatted = parseFloat(value || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return position === 'after' ? `${formatted} ${currency}` : `${currency} ${formatted}`
}

// Convert a local date string from a date picker to UTC for API submission.
// Pass endOfDay=true for "to" range bounds so the full day is included.
export function toUtcDateString (localDateString, prefs, endOfDay = false) {
  if (!localDateString) return ''
  const p  = prefs || getPrefs()
  const tz = p.timezone || 'Indian/Mauritius'
  let d    = dayjs.tz(localDateString, tz)
  if (endOfDay) d = d.endOf('day')
  return d.utc().format('YYYY-MM-DD HH:mm:ss')
}



// WEBPACK FOOTER //
// ./src/utils/dateFormat.js